import { Text } from "components/shared/text";
import { Fragment } from "react/jsx-runtime";

export const RowWithLeftTitle: React.FC<{
  title: string;
  rows: any;
  solutions: Solution[];
}> = ({ title, rows, solutions }) => {
  return (
    <group
      data-name="grid_container"
      data-width="auto"
      data-direction="column"
    >
      <group
        data-wrap="no"
        data-sticky-row=""
        data-name="heading_row"
      >
        <group
          data-width="auto"
          data-flex="no"
          data-sticky="left"
        >
          <group
            data-length="40"
            data-shrink="0"
            data-height="fit"
            data-align="center"
            data-justify="center"
            data-color="white"
            data-background={title === "PRIMARY" ? "accent-light" : "main"}
            data-border="inset"
          >
            <text
              data-orientation="vertical-invert"
            >{title}</text>
          </group>
          <group
            data-direction="column"
            data-width="auto"
          >
            {rows?.map((r: any) => (
              <group
                data-sticky="left"
                data-length="340"
                data-border="inset"
                data-space-horizontal="20"
                data-background="accent-xtralight"
              //data-align="center"
              //data-justify="center"
              //data-direction={r.caption2 ? "column" : "row"}
              >
                <group
                  data-direction="column"
                  data-justify="center"
                  data-height="50"
                >
                  <Text
                    //data-test="1"
                    data-wrap="wrap"
                    data-weight="500">
                    {r.caption}
                  </Text>
                  {r.caption2 && (
                    <Text
                      //data-test="2"
                      data-wrap="wrap"
                      data-weight="500"
                      data-space-left="20"
                    >
                      {r.caption2}
                    </Text>
                  )}
                </group>
              </group>
            ))}
          </group>
        </group>
        <group
          data-direction="column"
          data-width="auto"
        >
          {rows.map((row: any) => (
            <group
              data-wrap="no"
              data-width="auto"
            >
              {solutions.map((s: Solution) => (
                <group
                  data-length="260"
                  data-height="50"
                  data-border="inset"
                >
                  <Fragment key={`${s.pac.nom}_${s.pac.nombre}`}>
                    {row.render ? (
                      row.render(s)
                    ) : (
                      <></>
                      //<ValueBlock value={getValue!(s)} isTitle={isTitle} />
                    )}
                  </Fragment>
                </group>
              ))}
            </group>
          ))}
        </group>
      </group>
    </group>
  );
};
